<article class="box_default box_white" [ngClass]="{'box-form--error': errorAddInvite, 'with-overlay': modalView != VIEW_MODAL_NONE}">
  <core-layout-modal-feedback class="modal-feedback modal-feedback-success" *ngIf="modalView == VIEW_MODAL_ADD_INVITE_USER_SUCCESS"
    [type]="'success'"
    [message]="'Success'"
    [text]="'We have sent an invitation to the user, who will be<br/> able to log in after the invitation has been accepted.'"
    [buttonText]="'Ok'"
    (action)="onInviteSuccess($event)">
  </core-layout-modal-feedback>
  <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == VIEW_MODAL_ADD_INVITE_USER_ERROR"
    [type]="'fail'"
    [message]="'Error'"
    [text]="modalErrorText"
    [buttonText]="'OK'"
    (action)="dismiss($event)">
  </core-layout-modal-feedback>
  <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == VIEW_MODAL_LOAD_GROUPS_ERROR"
    [type]="'fail'"
    [message]="'Error'"
    [text]="'Form hasn’t loaded correctly. Please try again. If the error persists, please reach out to our support team through the Help Me button.'"
    [buttonText]="'Try again'"
    (action)="tryAgain($event)"
    [secondButtonText]="'Cancel'"
    (secondButtonAction)="cancel()">
  </core-layout-modal-feedback>
  <div class="loader" *ngIf="(httpStatusGetGroups.code == 0  || groups == null) else invitationform">
    <div class="dimmed">
      <header>
        <div class="dimmed_flex">
          <div class="dimmed_title"></div>
        </div>
      </header>
      <div class="dimmed_data">
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_title"></div>
      </div>
      <div class="dimmed_data">
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_title"></div>
      </div>
    </div>
  </div>
  <ng-template #invitationform>
    <div class="box-form__action">
        <!-- HEADER -->
        <header class="box-header">
            <h3 class="header-invite">Invite a new user</h3>
        </header>
        <div class="box_main">
            <form [formGroup]="form">
                <span class="txt_error" *ngIf="errorAddInvite" >{{textError}}</span>
                <div class="box-form__asides">
                  <div class="box-form__lat">
                    <!--  -->
                    <div class="box_item">
                    <label class="box-label">NAME</label>
                    <input type="text" placeholder="Full Name" formControlName="name"/>
                    </div>
                    <!--  -->
                    <div class="box_item">
                    <label class="box-label">EMAIL</label>
                    <input type="email" placeholder="Email" formControlName="email" (keyup)="checkUpperCase($event)"/>
                    </div>
                  <!--  -->
                  <div class="box_groups_item">
                    <span *ngIf="errorLowerCase"  class="error-label">No capital letters are allowed</span>
                    <core-helpers-forms-select-multiple
                        [label]="'ADD USER TO GROUPS'"
                        [options]="groups"
                        (selectValue)="setGroupSelected($event)"
                    ></core-helpers-forms-select-multiple>
                  </div>
                  </div>
                  <div class="box-form__lat box-form_message">
                    <label class="box-label">CUSTOMIZE YOU MESSAGE</label>
                      <div class="invite-message">
                        <core-helpers-forms-wysiwyg-extended
                          [placeholder]="''"
                          [content]="message"
                          [emojis]="false"
                          (textChange)="onMessageChange($event)"
                        ></core-helpers-forms-wysiwyg-extended>
                      </div>
                  </div>
                </div>
                <div class="box_fieldset">
                    <core-helpers-forms-button-white [disabled]="form.invalid || buttonDisabled || errorLowerCase" [text]="'Send Invitation'" (click)= "onSubmit()"></core-helpers-forms-button-white>
                  <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="cancel()"></core-helpers-forms-button>
                </div>
            </form>
        </div>
    </div>
  </ng-template>
</article>
